import { PropTableValues } from "../../../../src/components";
import { Link } from 'gatsby';
import { AnimationVariants, Label } from '@primer/react-brand';
import { supportedComponents } from "../../../../scripts/components-with-animation";
import * as React from 'react';
export default {
  PropTableValues,
  Link,
  AnimationVariants,
  Label,
  supportedComponents,
  React
};